<template>
  <div id="container">
    <Loading :isLoading="this.isLoading"/>
    <div style="margin-top:30px;">
      <ReedirectButton />
    </div>
    <FilterButtons ref="filterButtonsComponent" :list_to_filter="requests" 
      v-on:filter-list-by-status="getRequestsFiltered($event)" />
    <div style="clear: both;"></div>
    <div style="margin-top:30px;" id="pendingRequest">
      <div>
        <p style="text-align:left;font-size:24px;color: #6B6969;font-weight:bold;font-family:Roboto;">{{descriptionText}}</p>
      </div>
      <div class="flex" style="margin-top:30px;">
        <SearchByRfc ref="searchByRfcComponent" :list_to_filter="requests"
          v-on:filter-info-by-rfc="getListFilteredByRfc($event)" />
      </div>
      <div class="flex" style="margin-top:30px;" v-if="requests_filtered.length <= 0">
        <p class="description">No se encontraron registros</p>
      </div>
      <table class="table tableNoDebtCertificateRequested" id="table-id" style="margin-top:20px;">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th v-on:click="sortTable('rfc')">
              <div class="grid grid-cols-2">
                <div>
                  RFC
                </div>
                <div>
                  <div class="arrow" v-if="'rfc' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('name')">
              <div class="grid grid-cols-2">
                <div>
                  NOMBRE
                </div>
                <div>
                  <div class="arrow" v-if="'name' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('email')">
              <div class="grid grid-cols-2">
                <div>
                  EMAIL
                </div>
                <div>
                  <div class="arrow" v-if="'email' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('budget_keys')">
              <div class="grid grid-cols-2">
                <div>
                  CLAVES PRESUPUESTALES
                </div>
                <div>
                  <div class="arrow" v-if="'budget_keys' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('created_at')">
              <div class="grid grid-cols-2">
                <div>
                  FECHA DE REGISTRO
                </div>
                <div>
                  <div class="arrow" v-if="'created_at' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-if="statusFilter != 'aceptado'"></th>
            <th v-if="statusFilter == 'pendiente'"></th>
            <th v-if="statusFilter == 'aceptado'"></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in requests_filtered" :key="item.id">
            <td>{{index+1}}</td>
            <td>{{item.rfc | capitalize}}</td>
            <td>{{item.name | camelize}} {{item.paternal_name | camelize}} {{item.maternal_name | camelize}}</td>
            <td>{{item.email}}</td>
            <td>{{item.budget_keys.join(', ') | capitalize}}</td>
            <td>{{item.created_at | moment}}</td>
            <td v-if="statusFilter != 'aceptado'" style="padding-left:0px;"><input type="button" class="acceptRequest" value="Aceptar" id="button_accept" v-on:click="generateCertificate(item)" /></td>
            <td v-if="statusFilter == 'pendiente'" style="padding-left:0px;"><input type="button" class="rejectRequest" value="Rechazar" id="button_reject" v-on:click="reject(item)" /></td>
            <td v-if="statusFilter == 'aceptado'" style="padding-left:0px;"><input type="button" class="viewHistory" value="Ver Documento" id="button_view_document" v-on:click="getCertificateDocument(item)" /></td>
            <td style="padding-left:0px;"><input type="button" class="viewHistory" value="Ver Historial" id="button_view_history" v-on:click="reedirect(`http://172.16.201.7/consultahistorialdemovimientos2.asp?rfcseleccionado=${item.rfc}&cartanoadeudo=si`)" /></td>
          </tr>
        </tbody>
      </table>
      <div v-show="requests_filtered.length > elementsPerPage" class='pagination-container' style="text-align:center;">
        <nav>
          <ul class="pagination pagination-requests">
            <li data-page="prev" style="cursor: pointer;">
              <span>Anterior<span class="sr-only">(current)</span></span>
            </li>
            <li data-page="next" id="prev" style="cursor: pointer;">
              <span>Siguiente<span class="sr-only">(current)</span></span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="form-group" style="visibility:hidden"> 	<!--		Show Numbers Of Rows 		-->
      <select class ="form-control" name="state" id="maxRows">
        <option value="5000">Show ALL Rows</option>
        <option value="5">5</option>
      </select>
    </div>
  </div>
</template>

<script>
import('@/assets/css/stylesheet.css')
import Swal from 'sweetalert2'
import Loading from '@/components/Loading/Loading.vue'
import ReedirectButton from '@/components/Forms/ReedirectButton.vue'
import FilterButtons from '@/components/FilterButtons/FilterButtons.vue'
import SearchByRfc from '@/components/Search/SearchByRfc.vue'

import User from '@/classes/User'
import NoDebtCertificate from '@/classes/NoDebtCertificate'
import { getPagination, filterByStatus } from '@/helpers/tablePagination'
import { descriptionRequestText } from '@/helpers/enums'
import { largeMonths } from '@/helpers/enums'

export default {
  data() {
    return {
      isLoading: false,
      noDebtCertificateObjectClass: null,
      userObjectClass: null,
      requests:[],
      requests_filtered: [],
      token_auth: "",
      elementsPerPage: 10,
      rfc: "",
      descriptionText: "Solicitudes Pendientes",
      rfcRequestAcepted: "",
      rfcRequestRejected: "",
      sortColumn: "",
      ascending: false,
      urlPdf: "",
      statusFilter: "pendiente",
      activeColorBackground: '#198F99',
      inactiveColorBackground: '#FFF',
      activeColorText: '#FFF',
      inactiveColorText: '#6B6969',
      activeBorderColor: "#198F99",
      inactiveBorderColor: "#6B6969",
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
      ccapi: process.env.VUE_APP_CCAPI,
    }
  },
  name: 'NoDebtCertificateRequestedComponent',
  components: {
    Loading,
    ReedirectButton,
    FilterButtons,
    SearchByRfc
  },
  mounted() {
    this.userObjectClass = new User();
    this.noDebtCertificateObjectClass = new NoDebtCertificate();
    this.login();
    this.getCurrentDate();
  },
  methods: {
    getRequestsFiltered(event) {
      this.statusFilter = event.status;
      this.changeDescriptionText(event.status);
      this.setNoDebtCertificateRequestFiltered(event.data).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requests_filtered.length);
      });
    },
    async getAllRequests() {
      return await this.noDebtCertificateObjectClass.getAllRequest(this.token_auth).then(response => {
        this.requests = response.data.response.data;
        return response;
      }).catch(error => {
        console.error(error);
      });
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;

        this.getAllRequests().then(response => {
          this.$refs.filterButtonsComponent.filterByStatus("pendiente");
        });
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }

      var ascending = this.ascending;

      this.requests_filtered.sort(function(a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0;
      })
    },
    reedirect(path) {
      this.isLoading = true;
      window.location = path;
    },
    accept(noDebtCertificate) {
      this.noDebtCertificateObjectClass.accept(this.token_auth, noDebtCertificate.id).then(response => {
        try {
          this.openLinkPdf(this.urlPdf);
          this.sendMailNotificationClient(noDebtCertificate.email, "La Carta de no Adeudo ha sido Aceptada", this.urlPdf).then(response => {
            this.urlPdf = ""; 
            this.getAllRequests().then(response => {
              this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
            });

            this.isLoading = false;
            Swal.fire({
              text: "La solicitud de Carta de no Adeudo ha sido aceptada",
              html: `<p style="font-size:18px;font-weight:bold;">La solicitud de Carta de no Adeudo ha sido aceptada y generada correctamente</p>`,
              confirmButtonText: "Aceptar",
              allowOutsideClick: false,
              icon: "success",
            }).then((response)=>{
            }); 
          }).catch(error => {

          });
        } catch (error) {
          Swal.fire({
            title: "Aviso",
            text: "Ocurrió un error al aceptar la Solicitud de Carta de no Adeudo",
            icon: "error",
          });
        }
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    reject(noDebtCertificate) {
      Swal.fire({
        title: "Aviso",
        text: `¿Desea rechazar la solicitud de ${this.camelize(noDebtCertificate.name)} ${this.camelize(noDebtCertificate.paternal_name)} ${this.camelize(noDebtCertificate.maternal_name)}?`,
        html: `<p style="font-size:18px;">¿Desea rechazar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(noDebtCertificate.name)} ${this.camelize(noDebtCertificate.paternal_name)} ${this.camelize(noDebtCertificate.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.noDebtCertificateObjectClass.reject(this.token_auth, noDebtCertificate.id).then(response => {
            this.sendMailNotificationClient(noDebtCertificate.email, "La Carta de no Adeudo ha sido Rechazada", "").then(response => {
              this.getAllRequests().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });

              this.isLoading = false;
                Swal.fire({
                  text: "La solicitud de Carta de no Adeudo ha sido rechazada",
                  html: `<p style="font-size:18px;font-weight:bold;">La solicitud de Carta de no Adeudo ha sido rechazada</p>`,
                  confirmButtonText: "Continuar",
                  allowOutsideClick: false,
                  icon: "success",
              }).then((response)=>{
                //this.$router.push({ name: 'HomeLoanRequest' });
              });
            }).catch(error => {

            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            });
          });
        }  
      });
    },
    generateCertificate(noDebtCertificate) {
      Swal.fire({
        title: "Aviso",
        text: `¿Desea aceptar la solicitud?`,
        html: `<p style="font-size:18px;">¿Desea aceptar la solicitud de <span style="font-weight:bold;">
          ${this.camelize(noDebtCertificate.name)} ${this.camelize(noDebtCertificate.paternal_name)} ${this.camelize(noDebtCertificate.maternal_name)}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;
          let sheetInfo = this.buildSheetInfo(noDebtCertificate);

          this.noDebtCertificateObjectClass.generateCertificate(this.token_auth, "fas", noDebtCertificate.id, sheetInfo).then(response => {
            this.urlPdf = response.data.response.url;
            this.accept(noDebtCertificate);
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            });
          });
        }
      });
    },
    openLinkPdf(pdf) {
      this.isLoading = true;
      var a = document.createElement('a');
      a.title = "Carta de no adeudo";
      a.target = "_blank";
      a.href = pdf;
      document.body.appendChild(a);
      a.click();
      this.isLoading = false;
    },
    buildSheetInfo(noDebtCertificate) {
      let currentDate = this.getCurrentDate();

      let sheetInfo = {
        "1": {
          dia: currentDate[0],
          mes: currentDate[1],
          anio: currentDate[2],
          rfc: noDebtCertificate.rfc,
          nombre_completo: `${this.camelize(noDebtCertificate.name)} ${this.camelize(noDebtCertificate.paternal_name)} ${this.camelize(noDebtCertificate.maternal_name)}` ,
          clave_presupuestal_1: noDebtCertificate.budget_keys[0] != undefined ? noDebtCertificate.budget_keys[0].toUpperCase() : "",
          clave_presupuestal_2: noDebtCertificate.budget_keys[1] != undefined ? noDebtCertificate.budget_keys[1].toUpperCase() : "",
          clave_presupuestal_3: noDebtCertificate.budget_keys[2] != undefined ? noDebtCertificate.budget_keys[2].toUpperCase() : ""
        },
      };

      return sheetInfo;
    },
    getCertificateDocument(noDebtCertificate) {
      this.isLoading = true;
      this.noDebtCertificateObjectClass.getCertificateDocument(this.token_auth, noDebtCertificate.id).then(response => {
        console.log(response.data.response.data.table.payload);
        this.downloadCertificateDocument(response.data.response.data.table.payload);
        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
        console.error(error);
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    downloadCertificateDocument(PdfDocument) {
      var link = document.createElement("a");
      link.download = `certificado_de_no_adeudo.pdf`;
      link.href = PdfDocument;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getCurrentDate() {
      let currentDate = [];
      var dateObj = new Date();
      var month = dateObj.getMonth() + 1; //months from 1-12
      var day = dateObj.getDate();
      var year = dateObj.getFullYear();
      
      if (month.toString().length < 2)
          month = '0' + month;
      if (day.toString().length < 2) 
          day = '0' + day;

      month = largeMonths[month.toString()];
      return currentDate = [day.toString(), month.toString(), year.toString().substr(-2)];
    },
    camelize(value) {
      if (value != "" && value != undefined) {
        let response = "";
        value = value.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function(match) {
          return match.charAt(match.length-1).toUpperCase();
        });
        response = value.charAt(0).toUpperCase() + value.substring(1);
        return response.replace(/([A-Z])/g, ' $1').trim(); 
      }

      return "";
    },
    async sendMailNotificationClient(email, message, url){
      var list_files = []
      if(url != ""){
        list_files.push({
          name: "certificado_de_no_adeudo.pdf",
          file: url
        })
      }
      
      return await this.axios.post(this.ccapi + "/send_mail", {
        business: "fas",
        mail:{
          business: "fas",
          process_type:"envio documentos",
          title:"Notificacion solicitud carta no adeudo",
          body_mail:this.encriptarMessage(this.bodyEmailNotificationClient(message)),
          mailing_list:[email],
          attachment_list:list_files
        }
      },
      {
          'Content-Type': 'application/json'
      })
      .then(response => {
      }).catch(error => {
      });
    },
    encriptarMessage(msg){
      const header = { "alg": "HS256", "typ": "JWT" }
      const encodedHeader = Buffer.from(JSON.stringify(header)).toString('base64')

      var data = {
          "html": msg
      }
      const encodedPayload = Buffer.from(JSON.stringify(data)).toString('base64')
      var jwtSecret = "u3E*aWShrxOv";
      const crypto = require('crypto')
      const signature = crypto.createHmac('sha256', jwtSecret).update(encodedHeader + '.' + encodedPayload).digest('base64')      
      return encodedHeader+"."+encodedPayload+"."+signature
    },
    bodyEmailNotificationClient(message){
      var bodyEmail = "<!DOCTYPE html> " +
        "<html lang='en'>" +
          "<head>" +
            "<meta charset='UTF-8'>" +
            "<meta name='viewport' content='width=device-width, initial-scale=1.0'>" +
            "<title>Document</title>" +
          "</head>" +
        "<body>" +
          "<div style='background:#c1d349;height: 130px;display: flex;width: 100%;margin:0 auto;'>" +
          "<div class='div_centrado' style='margin:0 auto;background:white;width:77%;height:640px;margin-top:50px;border-radius:14px; text-align: center;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);'>" +
            "<p style='margin-top:40px;font-family:Roboto,Arial;font-size:22px;color:#6E6E6E;font-weight:bold;'>" +
              "Notificacion solicitud carta no adeudo" +
            "</p>" +
            
            "<p style='margin-top:40px;font-family:Roboto,Arial;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;'>" +
              message+
              "<br>"+
              "<br>"+
            "</p>" +
            "<p style='margin-top: 70px;font-family:Roboto,Arial;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;'>" +
                "Para cualquier pregunta reenvíe este mensaje, estaremos dispuestos a ayudarle."+
            "</p>"+
            "<p style='font-family:Roboto,Arial;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: justify;'>" +
              "Saludos." +
              "<br>" +
              "El equipo de FAS." +
            "</p>" +
            "<hr style='width: 89%;margin-top: 40px; border: 1px solid #c1d349;'>"+
            "<p style='margin-top: 40px;font-family:Roboto,Arial;color:#403F3F;padding-left: 60px;padding-right: 60px;text-align: justify; font-size: 13px;'> "+
                "Si este email ha sido enviado a bandeja de correos no deseados o spam, debe enviarlo a su bandeja de entrada, de lo contrario no funcionara el link adjunto** "+
            "</p>" +
            "<p style='font-family:Roboto,Arial;color:#8e8e8e;padding-left: 60px;padding-right: 60px;text-align: center;margin-top:40px;'>"+
              "FAS le ha enviado este mensaje"+
              "<br>"+
              "<a href='http://200.92.206.58:90/no-debt-certificate/no-debt-certificate-request' style='text-decoration:none;'>FAS</a>"+
            "</p>"+
          "</div>"+
          "</div>"+
          "<div style='background:#fcfcfc;height: 570px;display: flex;justify-content: center; width: 50%;margin:0 auto;'>"+
          
          "</div>"+
        "</body>"+
      "</html>"
      return bodyEmail
    },
    changeDescriptionText(buttonSelected) {
      this.descriptionText = descriptionRequestText[buttonSelected];
    },
    async setNoDebtCertificateRequestFiltered(requestFiltered) {
      this.requests_filtered = requestFiltered;
    },
    getListFilteredByRfc(event) {
      let requestFilteredByStatus = filterByStatus(event, 'status', this.statusFilter);
      this.setNoDebtCertificateRequestFiltered(requestFilteredByStatus).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requests_filtered.length);
      });
    },
    moveScroll(selector){
      let scrollTo = $('#'+selector);

      $('html, body').animate({
        scrollTop: $(scrollTo).offset().top
      }, 700);
    },
  }
}
</script>